export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref15007.18401eac.jpg";